import React from 'react';
import kkbwealthLogo from '../../assests/kkbwealthbg.png';

const C = {
  bgDark: '#0B5867',   // Deep Teal
  bgMid: '#2B6873',   // Mid Teal
  bgLight: '#9FBCC0',   // Mist
  accent: '#FF8C7A',   // Coral
  success: '#4ade80',   // Green
  danger: '#ef4444',   // Red
  white: '#FFFFFF',
  textSecondary: '#E2E8F0',
  glass: 'rgba(255, 255, 255, 0.08)',
  border: 'rgba(255, 255, 255, 0.15)',
};

const Footer = () => {
  return (
    <footer style={{ padding: '100px 30px 60px', borderTop: `1px solid ${C.border}`, background: 'rgba(0,0,0,0.2)' }}>
      <div style={{ maxWidth: 1300, margin: '0 auto' }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '60px', marginBottom: '80px' }}>
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '25px' }}>
              <img src={kkbwealthLogo} alt="KKB Wealth Logo" style={{ height: '60px', width: '80px', background: 'transparent' }} />
            </div>
            <p style={{ color: C.white, opacity: 0.7, lineHeight: 1.6, maxWidth: 280, fontSize: '0.95rem' }}>
              Precision capital. Proprietary intelligence. India's frontier in tech-driven investment.
            </p>
          </div>

          <div>
            <h4 style={{ color: C.bgLight, fontSize: '0.8rem', letterSpacing: '2px', marginBottom: '25px', fontWeight: 700 }}>CAPABILITIES</h4>
            <ul style={{ listStyle: 'none', padding: 0, display: 'flex', flexDirection: 'column', gap: '15px', color: C.white, opacity: 0.7, fontSize: '0.9rem' }}>
              <li key="f-cap-1">Capital Strategy</li>
              <li key="f-cap-2">Tech Ventures</li>
              <li key="f-cap-3">Portfolio Management</li>
              <li key="f-cap-4">Corporate Advisory</li>
            </ul>
          </div>

          <div>
            <h4 style={{ color: C.bgLight, fontSize: '0.8rem', letterSpacing: '2px', marginBottom: '25px', fontWeight: 700 }}>COMPANY</h4>
            <ul style={{ listStyle: 'none', padding: 0, display: 'flex', flexDirection: 'column', gap: '15px', color: C.white, opacity: 0.7, fontSize: '0.9rem' }}>
              <li key="f-com-1">About KKB</li>
              <li key="f-com-2">Leadership</li>
              <li key="f-com-3">Careers</li>
              <li key="f-com-4">Press</li>
            </ul>
          </div>

          <div>
            <h4 style={{ color: C.bgLight, fontSize: '0.8rem', letterSpacing: '2px', marginBottom: '25px', fontWeight: 700 }}>INSIGHTS</h4>
            <ul style={{ listStyle: 'none', padding: 0, display: 'flex', flexDirection: 'column', gap: '15px', color: C.white, opacity: 0.7, fontSize: '0.9rem' }}>
              <li key="f-ins-1">Research</li>
              <li key="f-ins-2">Market Updates</li>
              <li key="f-ins-3">Whitepapers</li>
              <li key="f-ins-4">Events</li>
            </ul>
          </div>
        </div>
        <div style={{ borderTop: `1px solid ${C.border}`, paddingTop: '40px', display: 'flex', justifyContent: 'space-between', color: C.white, opacity: 0.4, fontSize: '0.8rem' }}>
          <span>© 2026 KKB Private Limited</span>
          {/* <div style={{ display: 'flex', gap: '30px' }}>
            <span key="loc-mumbai">Mumbai</span>
            <span key="loc-singapore">Singapore</span>
            <span key="loc-dubai">Dubai</span>
          </div> */}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
